<template>
    <div class="exchange">
        <div class="title2" style="margin-top: 0px;">{{ $t("exchange.title") }}</div>
        <div class="exchange-box">
            <div class="choseCoinContainer">
                <div class="choseCoin">
                    <el-dropdown @command="selectPool" trigger="click"  slot="dropdown">
                        <div class="curPool">
                            <div class="coinBtn" v-if="mode == 1">
                                <img src="@/assets/images/mpc/XL.png"/>
                                <span>XL</span>
                            </div>
                            <div class="coinBtn" v-if="mode == 2">
                                <img src="@/assets/images/mpc/USDT.png"/>
                                <span>USDT</span>
                            </div>
                            <div class="coinBtn" v-if="mode == 3">
                                <img src="@/assets/images/mpc/GTS.png"/>
                                <span>GTS</span>
                            </div>
                            <div class="coinBtn" v-if="mode == 4">
                                <img src="@/assets/images/mpc/APT.png"/>
                                <span>APT</span>
                            </div>
                            <div class="coinBtn" v-if="mode == 5">
                                <img src="@/assets/images/mpc/WINE.png"/>
                                <span>WINE</span>
                            </div>
                            <div class="arrow"><i class="el-icon-caret-bottom"></i></div>
                        </div>
                        <el-dropdown-menu class="poolList">
                            <el-dropdown-item command="1" class="first">
                                <img src="@/assets/images/mpc/XL.png"/>
                                <span>XL</span>
                            </el-dropdown-item>
                            <el-dropdown-item command="5" class="last">
                                <img src="@/assets/images/mpc/WINE.png"/>
                                <span>WINE</span>
                            </el-dropdown-item>
                            <el-dropdown-item command="2" >
                                <img src="@/assets/images/mpc/USDT.png"/>
                                <span>USDT</span>
                            </el-dropdown-item>
                            <el-dropdown-item command="3" >
                                <img src="@/assets/images/mpc/GTS.png"/>
                                <span>GTS</span>
                            </el-dropdown-item>
                            <el-dropdown-item command="4" class="last">
                                <img src="@/assets/images/mpc/APT.png"/>
                                <span>APT</span>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>

                    <div class="coinBalance" v-if="mode == 1">
                        {{ $t("common.balance") }}: {{ showDataAuto(myXlBalance) }}
                    </div>
                    <div class="coinBalance" v-else-if="mode == 2">
                        {{ $t("common.balance") }}: {{ showDataAuto(myUsdtBalance) }}
                    </div>
                    <div class="coinBalance" v-else-if="mode == 5">
                        {{ $t("common.balance") }}: {{ showDataAuto(myMineBalance) }}
                    </div>
                    <div class="coinBalance" v-else>
                        {{ $t("common.balance") }}: {{ showDataAuto(defaultBalance) }}
                    </div>
                </div>
                <div class="inputCoin" tabindex="0">
                    <el-input ref="soldInput" placeholder="0.0" @input="changeSoldAmount" v-model="soldInputAmt"></el-input>
                    <div class="selectRate">
                        <div @click="maxXlAmount">{{$t('common.all')}}</div>
                    </div>
                </div>
            </div>

            <div class="turn" >
                <!-- <img src="@/assets/images/mpc/turn.png"/> -->
                <div><i class="el-icon-bottom"></i></div>
            </div>

            <div class="choseCoinContainer">
                <div class="choseCoin">
                    <el-dropdown @command="selectPool" trigger="click"  slot="dropdown">
                        <div class="curPool">
                            <div class="coinBtn" v-if="mode == 1 || mode == 3 || mode == 4 || mode == 5">
                                <img src="@/assets/images/mpc/STC.png"/>
                                <span>STC</span>
                            </div>
                            <div class="coinBtn" v-if="mode == 2">
                                <img src="@/assets/images/mpc/MPC.png"/>
                                <span>MPC</span>
                            </div>
                            <div class="arrow"><i class="el-icon-caret-bottom"></i></div>
                        </div>
                        <el-dropdown-menu class="poolList">
                            <el-dropdown-item command="1" class="first">
                                <img src="@/assets/images/mpc/STC.png"/>
                                <span>STC</span>
                            </el-dropdown-item>
                            <el-dropdown-item command="2" class="last">
                                <img src="@/assets/images/mpc/MPC.png"/>
                                <span>MPC</span>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <div class="coinBalance" v-if="mode == 1 || mode == 3 || mode == 4 || mode == 5">
                        {{ $t("common.balance") }}: {{ showDataAuto(myStcBalance) }}
                    </div>
                    <div class="coinBalance" v-if="mode == 2">
                        {{ $t("common.balance") }}: {{ showDataAuto(myMpcBalance) }}
                    </div>
                </div>
                <div class="inputCoin" tabindex="0">
                    <el-input ref="getInput" placeholder="0.0" @input="changeGetAmount" v-model="getInputAmt"></el-input>
                    <div class="value">
                        <!-- ≈ {{getAmountValue}} USD -->
                    </div>
                </div>
            </div>

            <div class="tradeInfoContainer">
                <div class="item" v-if="mode == 1">
                    <div class="lable">{{ $t("exchange.price") }}：</div>
                    <div class="value">1 STC ≈ {{showDataAuto(stcToXlPrice)}} XL</div>
                </div>
                <div class="item" v-if="mode == 5">
                    <div class="lable">{{ $t("exchange.price") }}：</div>
                    <div class="value">1 STC ≈ {{showDataAuto(stcToMinePrice)}} WINE</div>
                </div>
                <div class="item" v-if="mode == 2">
                    <div class="lable">{{ $t("exchange.price") }}：</div>
                    <div class="value">1 USDT ≈ {{showDataAuto(mpcPrice)}} MPC</div>
                </div>
                <div class="item" v-if="mode == 3">
                    <div class="lable">{{ $t("exchange.price") }}：</div>
                    <div class="value">1 GTS ≈ {{showDataAuto(defaultPrice)}} XL</div>
                </div>
                <div class="item" v-if="mode == 4">
                    <div class="lable">{{ $t("exchange.price") }}：</div>
                    <div class="value">1 APT ≈ {{showDataAuto(defaultPrice)}} XL</div>
                </div>
            </div>

            <div class="func" @click="confirmExchange">{{ $t("exchange.title") }}</div>

        </div>
        
        <div class="title3">
            <span>{{ $t("exchange.myLogList") }}</span>
            <span>{{ $t("exchange.myTotalUsdt") }}：<i>{{ showDataAuto(totalData.usdtAmt) }} USDT</i></span>
        </div>
        <div class="myLogList">
            <div class="listHeader">
                <span>{{ $t("exchange.usdtAmt") }}</span>
                <span>{{ $t("exchange.time") }}</span>
                <span>{{ $t("exchange.mpcAmt") }}</span>
            </div>
            <div class="listBody" v-if="logList && logList.length>0">
                <div v-for="(item,index) in logList" :key="index">
                    <span>{{showDataAuto(convertFromByUnit(item.usdtAmt,18))}}</span>
                    <span>{{formatTimestamp(item.time*1000)}}</span>
                    <span>{{showDataAuto(convertFromByUnit(item.mpcAmt,18))}}</span>
                </div>
            </div>
            <div class="noData" v-else>
                <img src="@/assets/images/qai/empty.png"/>
                <span>{{$t('common.noData')}}</span>
            </div>
        </div>
    </div>
</template>

<script>
import bus from '@/assets/js/bus';
import { getUserName} from '@/assets/js/user';
import Web3 from 'web3';
export default {
	data() {
		return {
            walletAddress: "",
            web3Instance:null,
            mpcExchangeContractInstance:null,
            tokenXlContractInstance:null,
            tokenStcContractInstance:null,
            tokenUsdtContractInstance:null,
            tokenMpcContractInstance:null,

            soldInputAmt:"",
            getInputAmt:"",
            getAmountValue:0,
            
            mode:1,
            stcToXlPrice:0,
            stcToMinePrice:0,
            myStcBalance:0,
            
            myXlBalance:0,
            myMineBalance:0,
            
            mpcPrice:0,
            myUsdtBalance:0,
            myMpcBalance:0,

            defaultPrice:1,
            defaultBalance:0,

            logList:[],
            totalData:{
                usdtAmt:0,
                mpcAmt:0,
            }
		};
	},
    created() {
        bus.$off('clearWalletAddress');
        bus.$off('refreshWalletData');
        bus.$on('clearWalletAddress',async() =>  {
            this.web3Instance = null;
            this.mpcExchangeContractInstance = null;
            this.tokenXlContractInstance = null;
            this.tokenStcContractInstance = null;

            this.mpcHomeContractInstance = null;
            this.tokenUsdtContractInstance = null;
            this.tokenMpcContractInstance = null;
        });
        bus.$on('refreshWalletData',async(msg) =>  {
            this.walletAddress = getUserName();
            this.initWallet();
        });
    },
    mounted() {
        if(getUserName()){
            this.hideConnectWalletBox();
            this.walletAddress = getUserName();
            this.initWallet();
        }else{
            this.showConnectWalletBox();
            this.connectWallet();
        }
    },
    methods: {
        selectPool(val){
            if(this.mode == parseInt(val)){
                return;
            }
            this.mode = parseInt(val);
            this.getInputAmt = '';
            this.soldInputAmt = '';
        },
        changeSoldAmount() {
            if(this.mode == 1){
                var reg = /^(\.*)(\d+)(\.?)(\d{0,6}).*$/g
                if (reg.test(this.soldInputAmt)) {
                    this.soldInputAmt = this.soldInputAmt.toString().replace(reg, '$2$3$4');
                    this.getInputAmt = this.convertDown(this.soldInputAmt / this.stcToXlPrice,6);
                } else {
                    this.getInputAmt = '';
                    this.soldInputAmt = '';
                }
            }else if(this.mode == 5){
                var reg = /^(\.*)(\d+)(\.?)(\d{0,6}).*$/g
                if (reg.test(this.soldInputAmt)) {
                    this.soldInputAmt = this.soldInputAmt.toString().replace(reg, '$2$3$4');
                    this.getInputAmt = this.convertDown(this.soldInputAmt / this.stcToMinePrice,6);
                } else {
                    this.getInputAmt = '';
                    this.soldInputAmt = '';
                }
            }else if(this.mode == 2){
                var reg = /^(\.*)(\d+)(\.?)(\d{0,6}).*$/g
                if (reg.test(this.soldInputAmt)) {
                    this.soldInputAmt = this.soldInputAmt.toString().replace(reg, '$2$3$4');
                    this.getInputAmt = this.convertDown(this.soldInputAmt / this.mpcPrice,6);
                } else {
                    this.getInputAmt = '';
                    this.soldInputAmt = '';
                }
            }else{
                var reg = /^(\.*)(\d+)(\.?)(\d{0,6}).*$/g
                if (reg.test(this.soldInputAmt)) {
                    this.soldInputAmt = this.soldInputAmt.toString().replace(reg, '$2$3$4');
                    this.getInputAmt = this.soldInputAmt;
                } else {
                    this.getInputAmt = '';
                    this.soldInputAmt = '';
                }
            }
        },
        changeGetAmount() {
            if(this.mode == 1){
                var reg = /^(\.*)(\d+)(\.?)(\d{0,6}).*$/g
                if (reg.test(this.getInputAmt)) {
                    this.getInputAmt = this.getInputAmt.toString().replace(reg, '$2$3$4');
                    this.soldInputAmt = this.convertDown(this.getInputAmt * this.stcToXlPrice,6);
                } else {
                    this.getInputAmt = '';
                    this.soldInputAmt = '';
                }
            }else if(this.mode == 5){
                var reg = /^(\.*)(\d+)(\.?)(\d{0,6}).*$/g
                if (reg.test(this.getInputAmt)) {
                    this.getInputAmt = this.getInputAmt.toString().replace(reg, '$2$3$4');
                    this.soldInputAmt = this.convertDown(this.getInputAmt * this.stcToMinePrice,6);
                } else {
                    this.getInputAmt = '';
                    this.soldInputAmt = '';
                }
            }else if(this.mode == 2){
                var reg = /^(\.*)(\d+)(\.?)(\d{0,6}).*$/g
                if (reg.test(this.getInputAmt)) {
                    this.getInputAmt = this.getInputAmt.toString().replace(reg, '$2$3$4');
                    this.soldInputAmt = this.convertDown(this.getInputAmt * this.mpcPrice,6);
                } else {
                    this.getInputAmt = '';
                    this.soldInputAmt = '';
                }
            }else{
                var reg = /^(\.*)(\d+)(\.?)(\d{0,6}).*$/g
                if (reg.test(this.getInputAmt)) {
                    this.getInputAmt = this.getInputAmt.toString().replace(reg, '$2$3$4');
                    this.soldInputAmt = this.getInputAmt;
                } else {
                    this.getInputAmt = '';
                    this.soldInputAmt = '';
                }
            }
        },
        maxXlAmount(){
            if(this.mode == 1){
                this.soldInputAmt = this.toDecimalVal(this.myXlBalance,4);
            }else if(this.mode == 5){
                this.soldInputAmt = this.toDecimalVal(this.myMineBalance,4);
            }else if(this.mode == 2){
                this.soldInputAmt = this.toDecimalVal(this.myUsdtBalance,4);
            }else{
                this.soldInputAmt = 0;
            }
            this.changeSoldAmount();
        },
        initWallet(){
            this.web3Instance = new Web3(window.ethereum);
            this.mpcExchangeContractInstance = new this.web3Instance.eth.Contract(this.MpcExchange_Contract.abi, this.MpcExchange_Contract.address);
            this.tokenXlContractInstance = new this.web3Instance.eth.Contract(this.TokenXl_Contract.abi, this.TokenXl_Contract.address);
            this.tokenMineContractInstance = new this.web3Instance.eth.Contract(this.TokenMine_Contract.abi, this.TokenMine_Contract.address);
            this.tokenUsdtContractInstance = new this.web3Instance.eth.Contract(this.TokenUsdt_Contract.abi, this.TokenUsdt_Contract.address);

            this.tokenStcContractInstance = new this.web3Instance.eth.Contract(this.TokenStc_Contract.abi, this.TokenStc_Contract.address);
            this.tokenMpcContractInstance = new this.web3Instance.eth.Contract(this.TokenMpc_Contract.abi, this.TokenMpc_Contract.address);
            this.refreshWalletData();
        },
        refreshWalletData(){
            this.showLoadingBox();
            this.tokenStcContractInstance.methods.balanceOf(this.walletAddress).call().then((result) => {
                this.myStcBalance = this.convertFromByUnit(result,18);
            });
            this.tokenXlContractInstance.methods.balanceOf(this.walletAddress).call().then((result) => {
                this.myXlBalance = this.convertFromByUnit(result,18);
            });
            this.tokenMineContractInstance.methods.balanceOf(this.walletAddress).call().then((result) => {
                this.myMineBalance = this.convertFromByUnit(result,18);
            });
            this.tokenUsdtContractInstance.methods.balanceOf(this.walletAddress).call().then((result) => {
                this.myUsdtBalance = this.convertFromByUnit(result,18);
            });
            this.tokenMpcContractInstance.methods.balanceOf(this.walletAddress).call().then((result) => {
                this.myMpcBalance = this.convertFromByUnit(result,18);
            });
            this.mpcExchangeContractInstance.methods.findPrice().call().then((result) => {
                this.stcToXlPrice = this.convertFromByUnit(result._stcToXlPrice,18);
                this.stcToMinePrice = this.convertFromByUnit(result._stcToMinePrice,18);
                this.mpcPrice = this.convertFromByUnit(result._mpcPrice,18);
                this.hideLoadingBox();
            });
            this.mpcExchangeContractInstance.methods.findUserLogAll(this.walletAddress).call().then((result) => {
                this.logList = result;
                this.hideLoadingBox();
            });
            this.mpcExchangeContractInstance.methods.findUserTotal(this.walletAddress).call().then((result) => {
                this.totalData = {
                    usdtAmt:this.convertFromByUnit(result._totalUsdt,18),
                    mpcAmt:this.convertFromByUnit(result._totalMpc,18),
                }
            });
        },
        async confirmExchange(){
            let _this = this;
            if(!this.mpcExchangeContractInstance || !this.tokenXlContractInstance || !this.tokenMineContractInstance){
                return;
            }
            if(isNaN(this.soldInputAmt) || this.soldInputAmt <= 0){
                this.$message.warning({message: this.$t("exchange.plsInputAmt"),duration: 1500})
                return;
            }

            let method;
            if(this.mode == 1){
                if(this.soldInputAmt > this.myXlBalance || this.myXlBalance <= 0){
                    this.$message.warning({message: this.$t("common.xlBalanceOut"),duration: 1500})
                    return;
                }
                this.showConfirmBox(2,"XL");
                let soldFinalBigNumber = this.convertToBigNumberByUnit(this.soldInputAmt,18);
                let soldAllowance = await this.tokenXlContractInstance.methods.allowance(this.walletAddress, this.MpcExchange_Contract.address).call();
                let soldAllowanceBigInt = this.convertToBigIntByUnit(soldAllowance,0);
                let finalBigInt = this.convertToBigIntByUnit(this.soldInputAmt,18);
                if(finalBigInt > soldAllowanceBigInt){
                    if(!await this.tokenApprove(this.tokenXlContractInstance,this.walletAddress,this.MpcExchange_Contract.address,soldFinalBigNumber)){
                        this.$message.warning({message:  this.$t("common.approveXlFail"),duration: 1500});
                        this.hideConfirmBox();
                        return;
                    }
                }
                method = this.mpcExchangeContractInstance.methods.exchangeStc(1,soldFinalBigNumber);
            }else if(this.mode == 5){
                if(this.soldInputAmt > this.myMineBalance || this.myMineBalance <= 0){
                    this.$message.warning({message: this.$t("common.mineBalanceOut"),duration: 1500})
                    return;
                }
                this.showConfirmBox(2,"WINE");
                let soldFinalBigNumber = this.convertToBigNumberByUnit(this.soldInputAmt,18);
                let soldAllowance = await this.tokenMineContractInstance.methods.allowance(this.walletAddress, this.MpcExchange_Contract.address).call();
                let soldAllowanceBigInt = this.convertToBigIntByUnit(soldAllowance,0);
                let finalBigInt = this.convertToBigIntByUnit(this.soldInputAmt,18);
                if(finalBigInt > soldAllowanceBigInt){
                    if(!await this.tokenApprove(this.tokenMineContractInstance,this.walletAddress,this.MpcExchange_Contract.address,soldFinalBigNumber)){
                        this.$message.warning({message:  this.$t("common.approveMineFail"),duration: 1500});
                        this.hideConfirmBox();
                        return;
                    }
                }
                method = this.mpcExchangeContractInstance.methods.exchangeStc(2,soldFinalBigNumber);
            }else if(this.mode == 2){
                if(this.soldInputAmt > this.myUsdtBalance || this.myUsdtBalance <= 0){
                    this.$message.warning({message: this.$t("common.usdtBalanceOut"),duration: 1500})
                    return;
                }
                let soldFinalBigNumber = this.convertToBigNumberByUnit(this.soldInputAmt,18);
                let soldAllowance = await this.tokenUsdtContractInstance.methods.allowance(this.walletAddress, this.MpcExchange_Contract.address).call();
                let soldAllowanceBigInt = this.convertToBigIntByUnit(soldAllowance,0);
                let finalBigInt = this.convertToBigIntByUnit(this.soldInputAmt,18);
                if(finalBigInt > soldAllowanceBigInt){
                    if(!await this.tokenApprove(this.tokenUsdtContractInstance,this.walletAddress,this.MpcExchange_Contract.address,soldFinalBigNumber)){
                        this.$message.warning({message:  this.$t("common.approveUsdtFail"),duration: 1500});
                        this.hideConfirmBox();
                        return;
                    }
                }
                method = this.mpcExchangeContractInstance.methods.exchangeMpc(soldFinalBigNumber);
            }else if(this.mode == 3){
                this.$message.warning({message: this.$t("common.test1BalanceOut"),duration: 1500})
                return;
            }else{
                this.$message.warning({message: this.$t("common.test2BalanceOut"),duration: 1500})
                return;
            }
            let bnbAmount = null;
            
            let gasprice = await this.web3Instance.eth.getGasPrice();
            console.log("gasPrice:",gasprice);
            method.estimateGas({from: this.walletAddress, value:bnbAmount}).then(function(result){
                console.log("estimateGas:",result);
            }).catch((err) => {
                console.log("estimateGas:",err)
            });

            this.setConfirmBox(2);
            this.contractSend(method,this.walletAddress,bnbAmount).then(function(result){
                _this.hideConfirmBox();
                if(result.status){
                    _this.$message.success({message: _this.$t("exchange.exchangeSuccess"),duration: 1500});
                    _this.refreshWalletData();
                }else{
                    _this.$message.error({message: _this.$t("exchange.exchangeFail"),duration: 1500});
                }
            }).catch((err) => {
                _this.hideConfirmBox();
                _this.$message.error({message: _this.$t("exchange.exchangeFail"),duration: 1500});
            });
        }
    },
    beforeDestroy() {
    }
};
</script>
<style lang='less'>
.inputCoin{
    .el-input{
        height: 100%;
        width:100%;
    }
    input{
        border:none;
        font-size:20px;
        color: #ffffff;
        height: 100%;
        border:2px solid rgba(255, 255, 255, 0);
        border:none;
        background: transparent !important;
        text-align: right;
        font-weight: bold;
    }
    input:focus{
        outline: none;
        border:2px solid #ffffff;
        border:none;
        // color: #FFFFFF;
    }
    input::-webkit-input-placeholder{
        color: #A2BED9;
        font-weight:normal;
    }
}
.curPool{
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    background: rgba(0,118,255,0.15);
    border-radius: 10px;
    height: 35px;
    width: 118px;
    .coinBtn{
        display: flex;
        align-items: center;
        margin-left: 12px;
        img{
            width: 22px;
            height: 22px;
            border-radius: 100%;
        }
        span{
            color: #ffffff;
            margin-left: 10px;
            font-size: 16px;
            font-weight: 600;
        }
    }
    .arrow{
        margin-right: 12px;
        i{
            color: #ffffff;
            font-size: 12px;
        }
    }
}

.poolList{
    padding:0px;
    border: none;
    margin-top: 6px!important;
    width: 100px;
    border-radius: 10px;
    .popper__arrow{
        // display: none;
    }
    .el-dropdown-menu__item{
        // font-size: 14px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        // height: 40px;
        // width: 80px;
        // line-height: 40px;
        text-align: center;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 4px 10px;
        background-color: #ffffff;
        // border-radius: 50px;
        img{
            width: 20px;
            height: 20px;
            border-radius: 100%;
        }
        span{
            color: #000000!important;
            margin-left: 8px;
            font-size: 13px;
            font-weight: bold;
        }
    }
    .el-dropdown-menu__item:hover{
        background-color: #eeeeee;
    }
    .first{
        border-radius: 10px 10px 0px 0px;
    }
    .last{
        border-bottom: none!important;
        border-radius: 0px 0px 10px 10px;
    }
}
</style>
<style lang='less' scoped>
.exchange{
    padding-top: 10px;
    padding-bottom: 20px;
    .exchange-box{
        margin:0px 10px;
        padding: 25px 25px 35px 25px;
        background:url('~@/assets/images/mpc/bg-pledge.png') 0px 0px no-repeat;
        background-size: 100% 100%;
    }
    .choseCoin{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 5px;
        
        .coinBalance{
            font-size: 13px;
            color:#9ABCDF;
            text-align: right;
        }
    }

    .inputCoin{
        padding: 15px 0px 15px 0px;
        background:url('~@/assets/images/mpc/bg-input2.png') 0px 0px no-repeat;
        background-size: 100% 100%;
        .selectRate{
            display: flex;
            justify-content: flex-end;
            align-items: center;
            gap:4px;
            margin-right: 10px;
            margin-top: 6px;
            div{
                border-radius: 20px;
                font-size: 12px;
                width: 45px;
                height: 20px;
                line-height: 20px;
                color: #ffffff;
                // font-weight: bold;
                cursor: pointer;
                background: #3161E7;
            }
        }
        .value{
            margin-top: 6px;
            text-align: right;
            height: 22px;
            color: #747A9A;
            padding-right: 15px;
        }
    }

    .turn{
        margin: 18px auto 15px auto;
        div{
            width: 30px;
            height: 30px;
            border-radius: 30px;
            background-color: #aaaaaa;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: auto;
            i{
                font-size: 13px;
                color: #000000;
            }
        }
        img{
            width: 30px;
            height: 30px;
            cursor: pointer;
        }
    }

    .tradeInfoContainer{
        margin-top: 20px;
        display: flex;
        flex-direction: column;
        gap: 6px;
        .item{
            display: flex;
            justify-content: space-between;
            align-items: center;
            .lable{
                color: #9ABCDF;
                font-size: 13px;
            }
            .value{
                font-size: 13px;
                color: #ffffff;
            }
        }
    }

    .func {
        margin-top: 25px;
        font-size: 14px;
        height: 45px;
        line-height: 45px;
        color:#000000;
        text-align: center;
        cursor: pointer;
        background:url('~@/assets/images/mpc/bg-btn.png') 0px 0px no-repeat;
        background-size: 100% 100%;
    }


    .myLogList{
        margin: 0px 10px;
        padding: 18px 20px;
        background:url('~@/assets/images/mpc/bg-msg.png') 0px 0px no-repeat;
        background-size: 100% 100%;
        color: #ffffff;
        .listHeader{
            font-size: 13px;
            color: #9ABCDF;
            margin-bottom: 10px;
            padding-bottom: 8px;
            border-bottom: 1px solid rgba(200,200,200,0.5);
            display: flex;
            justify-content: space-between;
            align-items: center;
            text-align: left;
            span:first-child{
                text-align: left;
                flex:1;
            }
            span:nth-child(2){
                text-align: center;
                width: 130px;
            }
            span:last-child{
                text-align: right;
                flex:1;
            }
        }
        .listBody{
            div{
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-size: 13px;
                margin-bottom: 12px;
                color:#ffffff;
                span:first-child{
                    text-align: left;
                    flex:1;
                }
                span:nth-child(2){
                    text-align: left;
                    width: 130px;
                }
                span:last-child{
                    text-align: right;
                    flex:1;
                }
            }
        }
    }
}
</style>